module.exports = __webpack_public_path__ + "static/media/44_Print.ba32aadf.png";